import {
  SET_HOVER_LISTING_ID,
  SET_LISTING_ID,
  SET_OFF_MARKET_HOVER_PROPERTY_ID,
  SET_LOADING,
  SET_SHOW_MAP,
  SET_SHOW_TABLE_VIEW,
  SET_SAVE_SEARCH_MODAL,
  INCREMENT_LISTING_VIEW_COUNT,
  SET_OFF_MARKET_SEARCH,
  SET_MAP_LOADED,
  SET_MAP_ZOOM_READONLY,
  SET_CHOICE_PRESETS,
  SET_SEARCH_TABLE_COLUMN_KEYS,
  SET_UPDATE_RESULTS_ON_MAP_MOVE,
  SET_CALL_LIST_TABLE_VIEW
} from '../actions/ui';
import {
  CLEAR_CRITERIA, UPDATE_CRITERIA, TOGGLE_ASSET_CLASS
} from '../actions/criteria';
import {
  saveOffMarketSearchFlag,
  updateTableViewFlag,
  updateCallListTableViewFlag
} from '../../../helpers/local_storage';
import type { InsightsProperty, Profile } from 'bundles/connect/types';
export const DEFAULT_UI = {
  property: undefined,
  hoverSaleListingId: undefined,
  embeddedMode: undefined,
  loading: false,
  showMap: true,
  showTableView: false,
  callListTableView: true,
  updateResultsOnMapMove: false,
  showSaveSearchModal: false,
  mapLoaded: false,
  listingViewCount: 0,
  offMarketHoverPropertyId: undefined,
  offcanvasInsightsPropertyId: undefined,
  mapZoomReadonly: undefined,
  products: {
    prospecting: false
  },
  choicePresets: {},
};

export type UIState = {
  property?: any;
  hoverSaleListingId: string | undefined;
  embeddedMode: "rethink" | "buildoutCrm" | undefined;
  loading: boolean;
  showMap: boolean;
  showTableView: boolean;
  callListTableView: boolean;
  updateResultsOnMapMove: boolean;
  showSaveSearchModal: boolean;
  mapLoaded: boolean;
  listingViewCount: number;
  offMarketHoverPropertyId?: string;
  hoverProperty?: InsightsProperty;
  offcanvasInsightsPropertyId?: string;
  mapZoomReadonly?: number;
  products: {
    prospecting: boolean;
  };
  profile?: Profile;
  choicePresets: Record<string, any>;
  offMarketSearch?: boolean;
  listingId?: string;
  searchTableColumnKeys?: string[];
  profileSavedSearch?: boolean;
  staticCallList?: boolean;
};

export default function(state: UIState = DEFAULT_UI, action): UIState {
  switch (action.type) {
  case SET_OFF_MARKET_SEARCH:
    saveOffMarketSearchFlag(action.payload);
    return { ...state, offMarketSearch: action.payload, hoverProperty: undefined };
  case SET_OFF_MARKET_HOVER_PROPERTY_ID:
    return { ...state, offMarketHoverPropertyId: action.payload };
  case SET_HOVER_LISTING_ID:
    return { ...state, hoverSaleListingId: action.payload };
  case SET_LISTING_ID:
    return { ...state, listingId: action.payload };
  case SET_LOADING:
    return { ...state, loading: action.payload };
  case SET_SHOW_MAP:
    return { ...state, showMap: action.payload };
  case SET_SHOW_TABLE_VIEW:
    updateTableViewFlag(action.payload);
    return { ...state, showTableView: action.payload };
  case SET_CALL_LIST_TABLE_VIEW:
    updateCallListTableViewFlag(action.payload);
    return { ...state, callListTableView: action.payload };
  case SET_UPDATE_RESULTS_ON_MAP_MOVE:
    return { ...state, updateResultsOnMapMove: action.payload };
  case SET_SAVE_SEARCH_MODAL:
    return { ...state, showSaveSearchModal: action.payload, listingViewCount: 0, profileSavedSearch: true };
  case SET_CHOICE_PRESETS:
    return {
      ...state,
      choicePresets: {
        ...state.choicePresets,
        [action.payload.key]: action.payload.value,
      },
    };
  case SET_SEARCH_TABLE_COLUMN_KEYS:
    return { ...state, searchTableColumnKeys: action.payload };
  case INCREMENT_LISTING_VIEW_COUNT:
    return { ...state, listingViewCount: state.listingViewCount + 1 };
  case SET_MAP_LOADED:
    return { ...state, mapLoaded: true };
  case SET_MAP_ZOOM_READONLY:
    return { ...state, mapZoomReadonly: action.payload };
  case CLEAR_CRITERIA:
  case UPDATE_CRITERIA:
  case TOGGLE_ASSET_CLASS:
  default:
    return state;
  }
}
